// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"2be34e7b","258":"acb37aee","496":"f0ea2a4e","861":"0222d501"}[chunkId] + ".chunk.js";
};